<template>

  <div class="p-grid p-pb-6">
		<div class="p-col-12 p-pt-1 p-pb-1">
        <div class="p-grid">
          <div class="p-col-6 p-text-left">
            <h2>{{$t('notifications.title')}}</h2>
          </div>
          <div class="p-col-6 p-text-right">
            <Button v-if="notificationsEnhanced && notificationsEnhanced.length>0 && !$functions.isDemoMode(email)" :label="$t('notifications.download_button')" @click="download"/>
          </div>
        </div>
        <div class="irinox-form notifications-v2" >

          

            <div class="p-d-flex p-jc-between p-ai-start">
              <div class="p-d-flex p-flex-column">
                <div class="p-formgroup-inline p-ai-center">
                  <div class="p-field">
                    <MultiSelect v-model="filters.labsSelected" :options="filters.labs" 
                      :maxSelectedLabels="1" :placeholder="$t('notifications.filters.lab')"
                    :selectedItemsLabel="'{0} '+$t('notifications.filters.labs')" :emptyMessage="$t('dashboard.filter_remove')" />
                  </div>
                  <div class="p-field">
                    <MultiSelect v-model="filters.categoriesSelected" :options="filters.categories" optionLabel="name" optionValue="code"
                    :maxSelectedLabels="1" :placeholder="$t('notifications.filters.category')" 
                    :selectedItemsLabel="'{0} '+$t('notifications.filters.categories')" :emptyMessage="$t('dashboard.filter_remove')" />
                  </div>
                  <div class="p-field">
                    <MultiSelect v-model="filters.modelsSelected" :options="filters.models" optionLabel="name" optionValue="code"
                    :maxSelectedLabels="1" :placeholder="$t('notifications.filters.model')" 
                    :selectedItemsLabel="'{0} '+$t('notifications.filters.models')" :emptyMessage="$t('dashboard.filter_remove')" />
                  </div>
                  <div class="p-field">
                    <Dropdown id="period" v-model="periodSelected" :options="periods" optionLabel="name" optionValue="code"
                      :placeholder="$t('filter.period_ph')" />
                  </div>
                </div>
                <div class="p-formgroup-inline p-ai-center">
                  <!-- <div class="p-field">
                    <ToggleButton v-model="filters.types.all" @click="updateTypes()" :onLabel="$t('notifications.filters.type_all')" :offLabel="$t('notifications.filters.type_all')"  :disabled="false" :aria-label="$t('notifications.filters.type_all')"/> 
                  </div>
                  <div class="p-field">
                    <ToggleButton v-model="filters.types.alm" @click="updateTypes(type.ALARM)" :onLabel="$t('notifications.filters.type_alm') + ' (' + counterAlm + ')'" :offLabel="$t('notifications.filters.type_alm') + ' (' + counterAlm + ')'"  :disabled="false" :aria-label="$t('notifications.filters.type_alm')"/> 
                  </div>
                  <div class="p-field">
                    <ToggleButton v-model="filters.types.mnt" @click="updateTypes(type.ANOMALY)" :onLabel="$t('notifications.filters.type_mnt') + ' (' + counterMnt + ')'" :offLabel="$t('notifications.filters.type_mnt') + ' (' + counterMnt + ')'"  :disabled="false" :aria-label="$t('notifications.filters.type_mnt')"/> 
                  </div> -->
                  <div class="p-field">
                    <SelectButton v-model="filters.typeSelected" :options="typesOptions" optionLabel="name" aria-labelledby="multiple" :allowEmpty="false"/>
                  </div>
                </div>
              </div>
              <div class="p-d-flex p-mt-1">
                <div class="p-formgroup-inline p-ai-center">
                  <div class="search-bar p-jc-between p-text-center p-mb-3" style="width: 200px;">
                    <i class="pi pi-search" />
                    <InputText v-model="filters.search" :placeholder="$t('notifications.filters.search_free')"  style="width: 100px; background: transparent;" :aria-label="$t('notifications.filters.search')"/>
                    <i class="pi pi-times" @click="function() {filters.search=null}"/>
                  </div>
                </div>
              </div>
  
            </div>

            <div v-if="notificationsEnhanced && notificationsEnhanced.length>0">

            <DataTable :value="notifications" stripedRows 
              responsiveLayout="stack" 
              breakpoint="960px" 
              :autoLayout="true" sortField="timestamp" :sortOrder="-1" class="p-mt-3 notifcations-table">

              <Column field="timestamp" :header="$t('notifications.col_date')" sortable >
                <template #body="slotProps">
                  <div class="not-date">{{ $d(slotProps.data.timestamp*msConverter, 'notification') }}</div>
                  <div class="not-time">{{ $d(slotProps.data.timestamp*msConverter, is24hour ? 'time' : 'time12' ) }}</div>
                </template>
              </Column>
              
              <Column field="appliance.modelNumber" :header="$t('notifications.col_model')" sortable >
                <template #body="slotProps">
                  <div class="not-model">{{ $functions.fixModelName(slotProps.data.appliance.modelNumber) }}</div>
                  <div class="not-lab">{{ slotProps.data.appliance.labName ?? '-' }}</div>
                </template>
              </Column>
              
              <Column field="serialNumber" :header="$t('notifications.col_serial')" sortable >
              </Column>
              
              <Column field="appliance.payload" :header="$t('notifications.col_anomaly')" >
                <template #body="slotProps">
                  <div class="p-grid p-mt-0">
                    <div class="p-col-fixed p-d-flex p-ai-center" style="width: 50px;">
                      <img v-if="slotProps.data.type==type.ALARM && slotProps.data.payload.active" src="assets/irinox/icons/alarm_active.svg" :alt="$t('common.active')"/> 
                      <img v-else-if="slotProps.data.type==type.ALARM && !slotProps.data.payload.active" src="assets/irinox/icons/alarm_inactive.svg" :alt="$t('common.inactive')"/> 
                      <img v-else-if="slotProps.data.type==type.ANOMALY" src="assets/irinox/icons/maintenance.svg" :alt="$t('common.anomaly')"/> 
                    </div>
                    <div class="p-col">
                      <div v-if="slotProps.data.type==type.ALARM">
                        <div class="not-primary not-alarm">{{ slotProps.data.payload.name?$t('alarms.'+slotProps.data.payload.name):"-" }}</div>
                        <div class="not-secondary not-alarm">{{ slotProps.data.payload.name }}</div>
                      </div>
                      <div v-if="slotProps.data.type==type.ANOMALY">
                        <div class="not-primary not-anomaly" v-html="$t('notifications.anomaly_generic')"></div>
                        <!-- <div class="not-primary not-anomaly">{{ slotProps.data.payload.name }}</div>
                        <div class="not-secondary not-anomaly">{{ slotProps.data.payload.name }}</div> -->
                      </div>
                    </div>
                  </div>
                </template>
              </Column>

              
              
              <Column ></Column>

            </DataTable>

          </div>
          
          <div v-else class="p-mt-1">
            {{$t('notifications.empty_list')}}
          </div>
          
        </div>
    </div>
  </div>
	

  <IrinoxDialogDark :visible="dialog.error" mode="error" :message="$t('notifications.error_dialog')"
    :life="5000" @update:visible="dialog.error = $event" />

  <IrinoxDialogDark :visible="dialog.downloadSuccess" 
    mode="success" 
    :message="$t('notifications.download_success')"
    :life="3000" 
    @update:visible="dialog.downloadSuccess = $event" />

</template>

<script>
import AccountService from '../../service/AccountService';
import IrinoxDialogDark from '../IrinoxDialogDark.vue';
import { mapGetters } from 'vuex';
// import AlarmAccordion from "../AlarmAccordion.vue";
import {FilterService} from 'primevue/api';

export default {
    components: {
        IrinoxDialogDark,
        // AlarmAccordion,
    },
    data() {
        return {
          msConverter: 1000, // Set it to 1000 if API response is in seconds or to 1 if milliseconds
          type: {
            ALARM: "ALM",
            EVENT: "EVT",
            ANOMALY: "MNT",
          },
          notificationsRaw: [],
          notificationsEnhanced: [],
          notificationsFiltered: [],
          notifications: [],
          filters: {
            search: null,
            labs: [],
            labsSelected: [],
            categories: [],
            categoriesSelected: [],
            models: [],
            modelsSelected: [],
            // types: {
            //   all: true,
            //   alm: false,
            //   mnt: false,
            // },
            // typesSelected: []
            typeSelected: { name: this.$t('notifications.filters.type_all'), value: null },
          },
          dialog: {
            error: false,
            downloadSuccess: false
          },
          periods: [{
            code: 7,
            name: this.$t('filter.period_last_w')
          }, {
            code: 30,
            name: this.$t('filter.period_last_1m')
          }, {
            code: 60,
            name: this.$t('filter.period_last_2m')
          }, {
            code: 90,
            name: this.$t('filter.period_last_3m')
          }],
          periodSelected: 7,
        };
    },
    computed: {
      ...mapGetters({
          personaltoken: 'userdata/personaltoken',
          appliances: 'appliances/appliances',
          is24hour: 'userdata/is24hour',
          email: 'userdata/email',
        }),
        counterAlm() {
          return this.notificationsFiltered.filter(n => n.type === this.type.ALARM).length;
        },
        counterMnt() {
          return this.notificationsFiltered.filter(n => n.type === this.type.ANOMALY).length;
        },
        typesOptions() {
          return [
            { name: this.$t('notifications.filters.type_all'), value: null },
            { name: this.$t('notifications.filters.type_alm') + ' (' + this.counterAlm + ')', value: this.type.ALARM },
            { name: this.$t('notifications.filters.type_mnt') + ' (' + this.counterMnt + ')', value: this.type.ANOMALY },
          ];
        }
    },
    watch: {
      periodSelected: 'load',
      notificationsRaw: 'updateEnhanced',
      notificationsEnhanced: 'updateFiltered',
      'filters.search': 'updateFiltered',
      'filters.labsSelected': 'updateFiltered',
      'filters.modelsSelected': 'updateFiltered',
      'filters.categoriesSelected': 'updateFiltered',
      // 'filters.typesSelected': 'updateFiltered',
      'filters.typeSelected': 'updateNotifications',
      notificationsFiltered: 'updateNotifications'
    },
    created() {
      this.accountService = new AccountService();
    },
    mounted() {
      this.accountService.setNotificationsReadV2(this.personaltoken);
      this.buildFilters();
      this.load();
    },
    methods: {
      buildFilters() {
        this.appliances.forEach(function(a) {
          if(a.labName && !this.filters.labs.includes(a.labName)) {
            this.filters.labs.push(a.labName);
          }
          this.filters.categories.push({code: a.type, name: this.$t('dashboard.categories.'+a.type)});
          this.filters.models.push({code: a.modelNumber, name: this.$functions.fixModelName(a.modelNumber)});
        }.bind(this));
        this.filters.labs.sort();
        this.filters.categories = this.$functions.uniqByKeepFirst(this.filters.categories, item => item.code).sort((a,b) => this.$functions.compareStrings(a,b,'name'));
        this.filters.models = this.$functions.uniqByKeepFirst(this.filters.models, item => item.code).sort((a,b) => this.$functions.compareStrings(a,b,'name'));
      },
      load() {
        let timestamp = this.$moment().subtract(this.periodSelected, 'days').startOf('day').unix() * this.msConverter;
        this.accountService.getNotificationsV2(this.personaltoken, timestamp)
          .then(notifications => {
            this.notificationsRaw = notifications;
          })
          .catch(error => {
            console.error("EXCEPTION "+error);
            this.dialog.error = true;
          });
      },
      updateEnhanced() {
        this.notificationsEnhanced = [];
        this.notificationsRaw.forEach(function(n) {
          this.appliances.forEach(function(a) {
            if(n.serialNumber == a.serialNumber) {
              let obj = this.$functions.clone(n);
              obj.appliance = {
                modelNumber: a.modelNumber,
                category: a.type,
                name: a.name,
                labName: a.labName
              }
              this.notificationsEnhanced.push(obj);
            }
          }.bind(this));
        }.bind(this));
      },
      updateFiltered() {
        let temp = [];
        this.notificationsEnhanced.forEach(function(n) {
          let s = this.filters.search==null
            || FilterService.filters.contains(n.appliance.name, this.filters.search)
            || FilterService.filters.contains(n.appliance.modelNumber, this.filters.search)
            || FilterService.filters.contains(n.serialNumber, this.filters.search);
          let l = this.filters.labsSelected.length==0 
            || FilterService.filters.in(n.appliance.labName, this.filters.labsSelected);
          let m = this.filters.modelsSelected.length==0 
            || FilterService.filters.in(n.appliance.modelNumber, this.filters.modelsSelected);
          let c = this.filters.categoriesSelected.length==0 
            || FilterService.filters.in(n.appliance.category, this.filters.categoriesSelected);
          if(s && l && m && c) {
            temp.push(n);
          }
        }.bind(this));
        this.notificationsFiltered = temp;
      },
      updateNotifications() {
        let temp = [];
        this.notificationsFiltered.forEach(function(n) {
          // let a = this.filters.typesSelected.length==0 
          //   || FilterService.filters.in(n.type, this.filters.typesSelected);
          let a = this.filters.typeSelected.value == null 
            || FilterService.filters.equals(n.type, this.filters.typeSelected.value);
          if(a) {
            temp.push(n);
          }
        }.bind(this));
        this.notifications = temp;
      },
      // updateTypes(selectedType = null) {
      //   if(selectedType==null) {
      //     this.filters.types.alm = false;
      //     this.filters.types.mnt = false;
      //     setTimeout(function() {
      //       this.filters.typesSelected = [];
      //       this.filters.typesSelected.push(this.type.ALARM);
      //       this.filters.typesSelected.push(this.type.ANOMALY);
      //     }.bind(this), 100);
      //   } else if(selectedType == this.type.ALARM) {
      //     this.filters.types.all = false;
      //     this.filters.types.mnt = false;
      //     setTimeout(function() {
      //       this.filters.typesSelected = [];
      //       this.filters.typesSelected.push(this.type.ALARM);
      //     }.bind(this), 100);
      //   } else if(selectedType == this.type.ANOMALY) {
      //     this.filters.types.all = false;
      //     this.filters.types.alm = false;
      //     setTimeout(function() {
      //       this.filters.typesSelected = [];
      //       this.filters.typesSelected.push(this.type.ANOMALY);
      //     }.bind(this), 100);
      //   }
      // },
      clearFilters() {
        this.filters.search = null;
        this.filters.labsSelected = [];
        this.filters.categoriesSelected = [];
        this.filters.modelsSelected = [];
        // this.filters.typesSelected = [];
        this.filters.typeSelected = { name: this.$t('notifications.filters.type_all'), value: null };
      },
      download() {
        let timestamp = this.$moment().subtract(this.periodSelected, 'days').startOf('day').unix() * this.msConverter;
        this.accountService.downloadNotificationsV2(this.personaltoken, timestamp)
          .then((data) => {
            this.dialog.downloadSuccess = true;
            let blob=new Blob([data], {type: 'application/vnd.ms-excel'});
            let link=document.createElement('a');
            link.href=window.URL.createObjectURL(blob);
            link.download="notification_"+new Date().getTime()+".csv";
            link.click();
          })
          .catch(error => {
            console.error("EXCEPTION "+error);
            this.dialog.error = true;
          });
      },
      formatDate(name) {
        try {
          return this.$d(new Date(name), "medium");
        } catch(err) {
          console.error(err);
          return "Invalid date";
        }
      },
      formatTime(timestamp) {
        try {
          if(this.is24hour) {
            return this.$d(this.$functions.utcDate(timestamp,1000), "time");
          } else {
            return this.$d(this.$functions.utcDate(timestamp,1000), "time12");
          }
        } catch(err) {
          console.error(err);
          return "N/A";
        }
      }
    }
}
</script>

<style scoped>

.irinox-form .p-dropdown,
.irinox-form .p-multiselect {
  width: 200px;
}

</style>